import React from 'react';

import { useIntl } from 'ha/i18n';
import {
  RoomsFilterValue,
  RoomsValue,
  RoomsFilterCount,
} from 'ha/types/SearchFilters';
import { useFeatureFlags } from 'ha/modules/FeatureFlags';

import CommonCheckboxFilter from './CommonCheckboxFilter';
import CommonCheckboxTitleWithCount from './CommonCheckboxTitleWithCount';

interface Props {
  value: RoomsFilterValue;
  onChange: (value: RoomsFilterValue) => void;
  count?: RoomsFilterCount;
}

const RoomFilter: React.FC<Props> = ({ value, onChange, count }) => {
  const { T } = useIntl();

  const { searchShowRoomFilterCount } = useFeatureFlags();
  const withCounts = searchShowRoomFilterCount === 'on';

  const handleChange = React.useCallback(
    (newValue: RoomsValue[]) => {
      onChange({ bedroomCount: newValue });
    },
    [onChange],
  );

  return (
    <CommonCheckboxFilter
      options={[
        {
          value: RoomsValue.ONE,
          title: withCounts ? (
            <CommonCheckboxTitleWithCount
              title={`1 ${T('bedroom')}`}
              count={count?.one}
            />
          ) : (
            `1 ${T('bedroom')}`
          ),
          testLocator: 'RoomsFilter One',
        },
        {
          value: RoomsValue.TWO,
          title: withCounts ? (
            <CommonCheckboxTitleWithCount
              title={`2 ${T('bedroom')}`}
              count={count?.two}
            />
          ) : (
            `2 ${T('bedroom')}`
          ),
          testLocator: 'RoomsFilter Two',
        },
        {
          value: RoomsValue.THREE,
          title: withCounts ? (
            <CommonCheckboxTitleWithCount
              title={`3 ${T('bedroom')}`}
              count={count?.three}
            />
          ) : (
            `3 ${T('bedroom')}`
          ),
          testLocator: 'RoomsFilter Three',
        },
        {
          value: RoomsValue.FOUR_AND_MORE,
          title: withCounts ? (
            <CommonCheckboxTitleWithCount
              title={`4+ ${T('bedroom')}`}
              count={count?.overFour}
            />
          ) : (
            `4+ ${T('bedroom')}`
          ),
          testLocator: 'RoomsFilter Four',
        },
      ]}
      value={value.bedroomCount}
      onChange={handleChange}
    />
  );
};

export default RoomFilter;
